/**
 * Forgot Password Page
 * Request password reset email
 */

import { useState } from 'react'
import { Link } from 'react-router-dom'
import { apiClient } from '../../lib/api'
import { AuthShell, Field, Notice, Spinner } from './authParts'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSuccess(false)

    if (!email) {
      setError('メールアドレスを入力してください')
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setError('有効なメールアドレスを入力してください')
      return
    }

    setIsLoading(true)

    try {
      const response = await apiClient.post('/auth/request-reset', { email })

      if (response.success) {
        setSuccess(true)
      } else {
        setError(response.error || 'リクエストに失敗しました')
      }
    } catch (err) {
      setError('リクエスト中にエラーが発生しました')
    } finally {
      setIsLoading(false)
    }
  }

  if (success) {
    return (
      <AuthShell title="メールを送信しました">
        <Notice tone="ok">パスワード再設定のリンクを送信しました。メールをご確認ください（1時間有効）。</Notice>
        <p className="m-0 text-center text-[13px] text-ink-muted">届かない場合は、迷惑メールフォルダを確認するか、メールアドレスをご確認のうえもう一度お試しください。</p>
        <Link to="/login" className="gm-btn gm-btn-secondary gm-btn-block">ログイン画面に戻る</Link>
      </AuthShell>
    )
  }

  return (
    <AuthShell title="パスワードの再設定" lead="登録したメールアドレスに、再設定のリンクを送ります。">
      <form onSubmit={handleSubmit} className="grid gap-4" noValidate>
        <Field
          type="email"
          id="email"
          label="メールアドレス"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
            setError('')
          }}
          placeholder="your@email.com"
          autoComplete="email"
          disabled={isLoading}
          autoFocus
          error={error || undefined}
        />

        <button type="submit" disabled={isLoading} className="gm-btn gm-btn-primary gm-btn-block">
          {isLoading ? <Spinner /> : null}
          <span>{isLoading ? '送信しています' : '再設定のリンクを送る'}</span>
        </button>

        <p className="gm-auth-foot"><Link to="/login">ログイン画面に戻る</Link></p>
      </form>
    </AuthShell>
  )
}
